<template>
  <div class="dashboard-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <div>
        <h1 class="page-title">数据概览</h1>
        <p class="page-subtitle">实时监控 APTUS 运动平台核心数据指标</p>
      </div>
      <span class="update-time">{{ currentTime }}</span>
    </div>

    <!-- 核心指标卡片 -->
    <el-row :gutter="20" class="stat-row">
      <el-col :xs="24" :sm="12" :lg="8">
        <div class="stat-card stat-card--primary" @click="$router.push('/TerminalUserManagement')">
          <div class="stat-icon-wrap">
            <i class="el-icon-user-solid stat-icon"></i>
          </div>
          <div class="stat-body">
            <div class="stat-value">{{ numTerminalUser }}</div>
            <div class="stat-label">终端用户数量</div>
          </div>
          <i class="el-icon-arrow-right stat-arrow"></i>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :lg="8">
        <div class="stat-card stat-card--accent" @click="$router.push('/DeviceManagement')">
          <div class="stat-icon-wrap">
            <i class="el-icon-s-platform stat-icon"></i>
          </div>
          <div class="stat-body">
            <div class="stat-value">{{ numDevice }}</div>
            <div class="stat-label">接入设备数量</div>
          </div>
          <i class="el-icon-arrow-right stat-arrow"></i>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :lg="8">
        <div class="stat-card stat-card--success" @click="$router.push('/ActionDatabaseManagement')">
          <div class="stat-icon-wrap">
            <i class="el-icon-odometer stat-icon"></i>
          </div>
          <div class="stat-body">
            <div class="stat-value">{{ numAction }}</div>
            <div class="stat-label">动作库数量</div>
          </div>
          <i class="el-icon-arrow-right stat-arrow"></i>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="stat-row">
      <el-col :xs="24" :sm="12" :lg="12">
        <div class="stat-card stat-card--warning" @click="$router.push('/CourseDatabaseManagement')">
          <div class="stat-icon-wrap">
            <i class="el-icon-document-copy stat-icon"></i>
          </div>
          <div class="stat-body">
            <div class="stat-value">{{ numCourse }}</div>
            <div class="stat-label">课程数量</div>
          </div>
          <i class="el-icon-arrow-right stat-arrow"></i>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :lg="12">
        <div class="stat-card stat-card--info" @click="$router.push('/TrainPlanDatabaseManagement')">
          <div class="stat-icon-wrap">
            <i class="el-icon-date stat-icon"></i>
          </div>
          <div class="stat-body">
            <div class="stat-value">{{ numTrainPlan }}</div>
            <div class="stat-label">训练计划数量</div>
          </div>
          <i class="el-icon-arrow-right stat-arrow"></i>
        </div>
      </el-col>
    </el-row>

    <!-- 快捷入口 -->
    <el-row :gutter="20" class="shortcut-row">
      <el-col :xs="24">
        <div class="dashboard-card">
          <div class="card-header">
            <span class="card-title">
              <i class="el-icon-menu"></i> 快捷入口
            </span>
          </div>
          <div class="card-body shortcut-body">
            <div
              v-for="item in shortcuts"
              :key="item.path"
              class="shortcut-item"
              @click="$router.push(item.path)">
              <div class="shortcut-icon" :style="{ background: item.bg, color: item.color }">
                <i :class="item.icon"></i>
              </div>
              <div class="shortcut-text">{{ item.label }}</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      numTerminalUser: '0',
      numDevice: '0',
      numAction: '0',
      numCourse: '0',
      numTrainPlan: '0',
      currentTime: '',
      shortcuts: [
        { label: '设备管理', path: '/DeviceManagement', icon: 'el-icon-s-platform', bg: '#EFF6FF', color: '#2563EB' },
        { label: '终端用户', path: '/TerminalUserManagement', icon: 'el-icon-user-solid', bg: '#EDF7ED', color: '#2E7D32' },
        { label: '动作库', path: '/ActionDatabaseManagement', icon: 'el-icon-odometer', bg: '#FFF5EB', color: '#FF6F00' },
        { label: '课程管理', path: '/CourseDatabaseManagement', icon: 'el-icon-document-copy', bg: '#FFF8E6', color: '#F57F17' },
        { label: '训练计划', path: '/TrainPlanDatabaseManagement', icon: 'el-icon-date', bg: '#EFF6FF', color: '#2563EB' },
        { label: '设备报警', path: '/DeviceAlarm', icon: 'el-icon-bell', bg: '#FDECEC', color: '#C62828' },
        { label: '消息中心', path: '/NoticeManagement', icon: 'el-icon-message-solid', bg: '#F5F6F8', color: '#5E6670' },
        { label: '意见反馈', path: '/FeedbackManagement', icon: 'el-icon-s-comment', bg: '#F5F6F8', color: '#5E6670' }
      ]
    }
  },
  mounted () {
    this.updateTime()
    this.HomeGet()
  },
  methods: {
    updateTime () {
      var now = new Date()
      var pad = function (n) { return n < 10 ? '0' + n : n }
      this.currentTime = now.getFullYear() + '-' +
        pad(now.getMonth() + 1) + '-' +
        pad(now.getDate()) + ' ' +
        pad(now.getHours()) + ':' +
        pad(now.getMinutes()) + ':' +
        pad(now.getSeconds())
    },
    HomeGet: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_HomeGet, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            var d = response.data.data
            that.numTerminalUser = d.numTerminalUser || '0'
            that.numDevice = d.numDevice || '0'
            that.numAction = d.numAction || '0'
            that.numCourse = d.numCourse || '0'
            that.numTrainPlan = d.numTrainPlan || '0'
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.dashboard-page {
  padding: 8px 4px 24px;
}

.page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 24px;

  .page-title {
    font-size: 22px;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0 0 6px;
  }

  .page-subtitle {
    font-size: 13px;
    color: var(--text-secondary);
    margin: 0;
  }

  .update-time {
    font-size: 12px;
    color: var(--text-tertiary);
    font-family: var(--font-family-base);
    font-variant-numeric: tabular-nums;
  }
}

.stat-row {
  margin-bottom: 20px;
}

.stat-card {
  display: flex;
  align-items: center;
  padding: 24px;
  background: #FFFFFF;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-color);
  transition: transform 200ms ease, box-shadow 200ms ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);

    .stat-arrow {
      opacity: 1;
      transform: translateX(0);
    }
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    opacity: 0.06;
    transform: translate(30%, -30%);
  }

  &--primary::after { background: var(--color-primary); }
  &--accent::after { background: var(--color-accent); }
  &--success::after { background: var(--color-success); }
  &--warning::after { background: var(--color-warning); }
  &--info::after { background: var(--color-primary-lighter); }

  .stat-icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: var(--radius-md);
    margin-right: 16px;
    flex-shrink: 0;

    .stat-icon {
      font-size: 24px;
      color: #fff;
    }
  }

  .stat-body {
    flex: 1;
    min-width: 0;
  }

  .stat-value {
    font-size: 30px;
    font-weight: 700;
    color: var(--text-primary);
    line-height: 1.2;
    margin-bottom: 6px;
    font-family: var(--font-family-base);
    font-variant-numeric: tabular-nums;
  }

  .stat-label {
    font-size: 13px;
    color: var(--text-secondary);
    font-weight: 500;
  }

  .stat-arrow {
    font-size: 18px;
    color: var(--text-tertiary);
    margin-left: 12px;
    opacity: 0;
    transform: translateX(-6px);
    transition: all 200ms ease;
  }

  /* 卡片主题色 */
  &--primary .stat-icon-wrap { background: var(--color-primary); }
  &--accent .stat-icon-wrap { background: var(--color-accent); }
  &--success .stat-icon-wrap { background: var(--color-success); }
  &--warning .stat-icon-wrap { background: var(--color-warning); }
  &--info .stat-icon-wrap { background: var(--color-primary-lighter); }
}

.shortcut-row {
  margin-bottom: 20px;
}

.shortcut-body {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 20px;
}

.shortcut-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: calc(12.5% - 14px);
  min-width: 90px;
  padding: 16px 8px;
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: all 200ms ease;
  border: 1px solid transparent;

  &:hover {
    background: var(--color-primary-bg);
    border-color: var(--color-primary-bg);
    transform: translateY(-2px);

    .shortcut-icon {
      transform: scale(1.08);
    }
  }

  &:active {
    transform: translateY(0);
  }

  .shortcut-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: var(--radius-md);
    margin-bottom: 10px;
    font-size: 20px;
    transition: transform 200ms ease;
  }

  .shortcut-text {
    font-size: 13px;
    color: var(--text-secondary);
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
  }
}

.chart-row {
  margin-top: 4px;
}

.dashboard-card {
  background: #FFFFFF;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-color);
  overflow: hidden;

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid var(--border-color-light);

    .card-title {
      font-size: 15px;
      font-weight: 600;
      color: var(--text-primary);

      i {
        margin-right: 6px;
        color: var(--color-primary);
      }
    }
  }

  .card-body {
    padding: 20px;
    position: relative;
  }
}

@media (max-width: 1200px) {
  .shortcut-item {
    width: calc(25% - 12px);
  }

  .stat-card {
    padding: 18px;

    .stat-icon-wrap {
      width: 48px;
      height: 48px;

      .stat-icon {
        font-size: 20px;
      }
    }

    .stat-value {
      font-size: 26px;
    }
  }
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .stat-row,
  .chart-row {
    .el-col {
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .shortcut-item {
    width: calc(33.333% - 11px);
  }
}
</style>
